import type { ReactNode } from 'react'
import { Result } from 'antd'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { pageReadPerm } from '../constants/pagePerms'
import { useCanFn } from '../hooks/useCan'

// PermGate replaces a page the role may not read with a clear 403 notice instead
// of letting it render empty and fire failing requests.
export default function PermGate({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const can = useCanFn()
  const perm = pageReadPerm(pathname)
  if (perm && !can(perm)) {
    return (
      <Result
        status="403"
        title={t('common.noAccessTitle', 'Kein Zugriff')}
        subTitle={t('common.noAccessSub', 'Deine Rolle hat für diese Seite kein Leserecht ({{perm}}). Ein Owner kann das unter Team & Rollen ändern.', { perm })}
      />
    )
  }
  return <>{children}</>
}
